<template>
  <div class="home-wrapper__tabs">
    <div class="home-wrapper__tabs-block tree-scroll" v-if="$store.state.toggleSite === 'rbxtree'">
      <div
        @click="$store.state.currentTub.rbxtree = 'topups'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'topups'
        }"
      >
        <p>TOPUPS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'transfer'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'transfer'
        }"
      >
        <p>TRANSFER</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'gift'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'gift'
        }"
      >
        <p>GIFT</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'superPass'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'superPass'
        }"
      >
        <p>SUPER PASS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'logpass'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'logpass'
        }"
      >
        <p>LogPass</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'steam'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'steam'
        }"
      >
        <p>STEAM</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'tgStars'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'tgStars'
        }"
      >
        <p>TG STARS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'tgPremium'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'tgPremium'
        }"
      >
        <p>TG PREMIUM</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'pubg'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'pubg'
        }"
      >
        <p>PUBG MOBILE</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'genshin'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'genshin'
        }"
      >
        <p>GENSHIN</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'platformKeys'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'platformKeys'
        }"
      >
        <p>PLATFORM KEYS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'supercell'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'supercell'
        }"
      >
        <p>SUPERCELL</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'callOfDuty'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'callOfDuty'
        }"
      >
        <p>CALL OF DUTY</p>
      </div>
      <!--      <div
        @click="$store.state.currentTub.rbxtree = 'logpass'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'logpass',
        }"
      >
        <p>LOG+PASS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxtree = 'premium'"
        class="home-wrapper__tabs-item rbxtree"
        :class="{
          'active-tab-tree': $store.state.currentTub.rbxtree === 'premium',
        }"
      >
        <p>Premium</p>
      </div>-->
    </div>
    <div class="home-wrapper__tabs-block pier-scroll" v-if="$store.state.toggleSite === 'rbxpier'">
      <div
        @click="$store.state.currentTub.rbxpier = 'topups'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxpier === 'topups'
        }"
      >
        <p>TOPUPS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxpier = 'transfer'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxpier === 'transfer'
        }"
      >
        <p>TRANSFER ORDERS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxpier = 'gift'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxpier === 'gift'
        }"
      >
        <p>GIFT</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxpier = 'superPass'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxpier === 'superPass'
        }"
      >
        <p>SUPER PASS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxpier = 'platformKeys'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxpier === 'platformKeys'
        }"
      >
        <p>KEYS</p>
      </div>
      <!--      <div
        @click="$store.state.currentTub.rbxpier = 'logpass'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxpier === 'logpass'
        }"
      >
        <p>LOG+PASS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxpier = 'premium'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxpier === 'premium'
        }"
      >
        <p>Premium</p>
      </div>-->
    </div>
    <div class="home-wrapper__tabs-block pier-scroll" v-if="$store.state.toggleSite === 'rbxsea'">
      <div
        @click="$store.state.currentTub.rbxsea = 'topups'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxsea === 'topups'
        }"
      >
        <p>TOPUPS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxsea = 'transfer'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxsea === 'transfer'
        }"
      >
        <p>TRANSFER ORDERS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxsea = 'logpass'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxsea === 'logpass'
        }"
      >
        <p>LOG+PASS</p>
      </div>
      <div
        @click="$store.state.currentTub.rbxsea = 'premium'"
        class="home-wrapper__tabs-item rbxpier"
        :class="{
          'active-tab-pier': $store.state.currentTub.rbxsea === 'premium'
        }"
      >
        <p>Premium</p>
      </div>
    </div>
  </div>
</template>

<script>
import "./tablesTabs.scss";

export default {
  name: "TablesTabs",
  mounted() {
    // Полоса вкладок прокручивается — показываем активную, чтобы она не пряталась за краем
    const active = this.$el.querySelector(".active-tab-tree, .active-tab-pier");
    if (active) active.scrollIntoView({ block: "nearest", inline: "nearest" });
  }
};
</script>
